(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["custom-link-buttons"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.custom-linkbtn-slide').forEach(function (el) {
    var splide = new Splide(el, {
      type: 'slide',
      autoWidth: true,
      perMove: 1,
      gap: '20px',
      arrows: false,
      pagination: false,
      breakpoints: {
        768: {
          gap: '10px',
          arrows: true,
        },
        640: {
          gap: '10px',
        },
      },
    });
    splide.mount();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-recommendations"] && !Shopify.designMode) return;
  try {
    setTimeout(() => {
    document.querySelectorAll('.custom-product-card .product-swatches a').forEach(swatch => {
        swatch.addEventListener('click', function(e) {
            e.preventDefault();
            swatch.closest('.product-swatches').querySelectorAll('a.swatch.active').forEach(item => {
              item.classList.remove('active');
            });
            swatch.classList.add('active');
            const swatchURL = swatch.dataset.image;
            const imgElement = swatch.closest('.custom-product-card').querySelector('img');
            if (imgElement) {
                imgElement.src = swatchURL;
                imgElement.srcset = swatchURL;
            }
        });
    });
  }, 5000);
  } catch(e) { console.error(e); }
})();

})();
